import type { ReactNode } from 'react';

export const symbol_page_control: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M93.5-423.5Q70-447 70-480t23.5-56.5Q117-560 150-560t56.5 23.5Q230-513 230-480t-23.5 56.5Q183-400 150-400t-56.5-23.5ZM174-456q10-10 10-24t-10-24q-10-10-24-10t-24 10q-10 10-10 24t10 24q10 10 24 10t24-10Zm139.5 32.5Q290-447 290-480t23.5-56.5Q337-560 370-560t56.5 23.5Q450-513 450-480t-23.5 56.5Q403-400 370-400t-56.5-23.5ZM394-456q10-10 10-24t-10-24q-10-10-24-10t-24 10q-10 10-10 24t10 24q10 10 24 10t24-10Zm139.5 32.5Q510-447 510-480t23.5-56.5Q557-560 590-560t56.5 23.5Q670-513 670-480t-23.5 56.5Q623-400 590-400t-56.5-23.5ZM614-456q10-10 10-24t-10-24q-10-10-24-10t-24 10q-10 10-10 24t10 24q10 10 24 10t24-10Zm139.5 32.5Q730-447 730-480t23.5-56.5Q777-560 810-560t56.5 23.5Q890-513 890-480t-23.5 56.5Q843-400 810-400t-56.5-23.5Z"
		/>
	</svg>
);
